import React, {useCallback, useMemo, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import PolicyDwellingInfo from '../../HO/PolicyDwellingInfo/PolicyDwellingInfo';
import metadata from './CommercialPropertyCoveragesComponent.metadata.json5';
import messages from './CommercialPropertyCoveragesComponent.messages';

const getFormattedInfo = (message, key, value) => {
    return (
        <FormattedMessage
            {...message}
            values={{
                [key]: value
            }}
        />
    );
};

const getCellCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellCoverageLimit = (rowData) => {
    const limit = rowData.limit ? rowData.limit : '-';
    return (
        <span>
            {limit}
        </span>
    );
};

const getCellCoverageDeductible = (rowData) => {
    const deductible = rowData.deductible ? rowData.deductible : '-';
    return (
        <span>
            {deductible}
        </span>
    );
};

const getCellBuildingName = (index, rowData) => {
    let bname = '';
    if (rowData) {
        bname = `Building ${index + 1}: ${rowData.name}`;
    }
    return (
        <span>
            {bname}
        </span>
    );
};


function CommercialPropertyCoveragesComponent(props) {
    const { value: cpData } = props;
    const translator = useContext(TranslatorContext);
    const [openItems, setOpenItems] = useState([]);

    if (_.isEmpty(cpData) || cpData === undefined) {
        return null;
    }


    if(cpData && !_.isEmpty(cpData.locations) ) {
        const cpData1 = _.cloneDeep(cpData);
        cpData1.locations.forEach((location, index) => {
            cpData.locations[index].dwellingDTO = [];
            cpData.locations[index].dwellingDTO = location.buildings && !_.isEmpty(location.buildings) ? location.buildings : []  ;
        });
    }

    const policyLocationCoverages = useMemo(() => {
        const cpLocations = cpData.locations;
        return cpLocations;
    }, [cpData]);

    const getAddress = (address) => {
        const addressline2 = address.addressline2 ? `, ${address.addressline2}` : '';
       return `${address.addressLine1} ${addressline2}, ${address.city}, ${address.state} , ${address.postalCode}`;
    };

    const readValue = useCallback(
        (id, path) => {
            if (path === 'myPolicyLocations') {
                return policyLocationCoverages;
            }
            return _.get(policyLocationCoverages, path);
        },
        [policyLocationCoverages]
    );

    //Show/Hide package details code -- Start--
    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );

    const updateVisibility = useCallback((val) => {
        if (val && val.length > 0) {
            return true;
        }
        return false;
    }
    );

    

    const generateBuildingTableOverrides = useCallback((policyLocBuildings) => {
        const overrides = policyLocBuildings.map((building, index) => {
            return {
                [`buildingId${index}`]: {
                    content: getCellBuildingName(index, building)
                },
                

            };
        });
        return Object.assign({}, ...overrides);
    }, [policyLocationCoverages]);

    const generateCpLocationTableOverrides = useCallback(() => {
        const overrides = policyLocationCoverages.map((policyLocation, index) => {
            return { 
                [`homeAddressId${index}`]: {
                    content: getAddress(policyLocation.address)
                },
                [`buildingCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.buildings)
                },
                [`locationCoveragesTable${index}`]: {
                    data: policyLocation.coverages,
                    visible: !_.isEmpty(policyLocation.coverages)
                },
                [`locationBuildingsTable${index}`]: {
                    data: policyLocation.buildings
                },
                [`myPolicyLocationBuildings${index}`]: {
                    path: policyLocation.buildings
                },
                [`policyCPInfoComponent${index}`]: { 
                    value: policyLocation
                },
                ...generateBuildingTableOverrides(policyLocation.buildings),
                [`contentDetailToggle${index}`]: {
                    icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openItems, index)
                        ? translator(messages.hideDetails)
                        : translator(messages.showDetails)
                },
                [`packageDetailsID${index}`]: {
                    visible: _.includes(openItems, index),
                    show: openItems
                },
                [`showContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`operationsDetail${index}`]:{
                    value: policyLocation.operation
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [policyLocationCoverages, openItems, toggleShowHide, translator]);

    const resolveCallbackMap = {
        getCellCoverageName: getCellCoverageName,
        getCellCoverageLimit: getCellCoverageLimit,
        getCellCoverageDeductible: getCellCoverageDeductible,
        getCellBuildingName: getCellBuildingName
    };

    const resolveComponentMap = {
        policydwellingcomponent: PolicyDwellingInfo
    }

    const overrides = {
        repeatLocation: {
            data: policyLocationCoverages
        },
        ...generateCpLocationTableOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyLocationCoverages}
            overrideProps={overrides}
            resolveValue={readValue}
            callbackMap={resolveCallbackMap}
            componentMap={resolveComponentMap}
        />
    );
}

CommercialPropertyCoveragesComponent.propTypes = {
    value: PropTypes.shape({})
};

CommercialPropertyCoveragesComponent.defaultProps = {
    value: []
};

export default CommercialPropertyCoveragesComponent;
